import script from "./SupervisionBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupervisionBanner.vue?vue&type=script&lang=ts&setup=true"

import "./SupervisionBanner.vue?vue&type=style&index=0&id=7a568236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a568236"]])

export default __exports__